// Android web double-fires click events a few ms apart, which no person can do,
// so a repeat click on the same ad inside this window is the same physical tap.
export const DUPLICATE_CLICK_WINDOW_MS = 200

const lastPushedAt = new WeakMap()

export const pushAdClickToDataLayer = (clickDataElement, clickThroughUrl) => {
  const now = Date.now()
  const previous = lastPushedAt.get(clickDataElement)

  if (previous !== undefined && now - previous < DUPLICATE_CLICK_WINDOW_MS) {
    return
  }

  lastPushedAt.set(clickDataElement, now)

  window.dataLayer.push({
    event: 'gtm.click',
    'gtm.element': clickDataElement,
    'gtm.elementUrl': clickThroughUrl
  })
}
